import _compact from 'lodash/compact';
import { BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { ActionMenu } from 'ui/actionMenu/ActionMenu';
import { ActionMenuOption, AllowedActionMenuElements, MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { Overflow24 } from 'ui/icons/aurora/24px/Overflow24';
import { Export24 } from 'ui/icons/aurora/24px/Export24';
import { DatabaseBlock24 } from 'ui/icons/aurora/24px/DatabaseBlock24';
import { CSV_COPY, BLOCK_UNKNOWN_EVENTS_ACTION_MENU_TEXT } from '../constants';
import { useModalsContext } from '../contexts';
import { MergedCustomEvent } from '../types';
import { useExportCustomEvents } from '../hooks';

type Props = {
  allowNewCustomEvents: boolean;
  filteredCustomEvents: MergedCustomEvent[];
};

export const CustomEventsHeaderOverflowMenu = ({
  allowNewCustomEvents,
  filteredCustomEvents,
}: Props) => {
  const { showBlockModal } = useModalsContext();
  const exportCustomEventsCallback = useExportCustomEvents(filteredCustomEvents);

  const overflowOptions: ActionMenuOption[] = _compact([
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <Export24 />
          <span>{CSV_COPY.optionDisplayText}</span>
        </>
      ),
      id: CSV_COPY.id,
      onClick: () => exportCustomEventsCallback(),
    },
    allowNewCustomEvents && {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <DatabaseBlock24 />
          <span>{BLOCK_UNKNOWN_EVENTS_ACTION_MENU_TEXT.optionDisplayText}</span>
        </>
      ),
      description: BLOCK_UNKNOWN_EVENTS_ACTION_MENU_TEXT.descriptionText,
      id: BLOCK_UNKNOWN_EVENTS_ACTION_MENU_TEXT.id,
      onClick: showBlockModal,
    },
  ]);

  return (
    <ActionMenu align={MENU_ALIGNMENTS.RIGHT} options={overflowOptions}>
      <IconButton variant={BUTTON_VARIANTS.SECONDARY} size={BUTTON_SIZES.LARGE}>
        <Overflow24 />
      </IconButton>
    </ActionMenu>
  );
};
